import { render, staticRenderFns } from "./Smsaccept.vue?vue&type=template&id=240cf6d3"
import script from "./Smsaccept.vue?vue&type=script&lang=js"
export * from "./Smsaccept.vue?vue&type=script&lang=js"
import style0 from "./Smsaccept.vue?vue&type=style&index=0&id=240cf6d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports